module.exports = __webpack_public_path__ + "img/all.3811f03.png";